/**
* Animating Hero JS
* -----------------------------------------------------------------------------
*
* All the JS for the Animating Hero component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'animating-hero',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.animating-hero' ).each( function( key, val ) {
        const wave = $( this ).find( '.animating-hero__wave-wrapper' )[0];
        const height = $( this ).outerHeight();
        let topOffset = $( '.navbar' ).height();

        if ( $( '#wpadminbar' ).length ) {
          topOffset += $( '#wpadminbar' ).height();
        }
        const mm = gsap.matchMedia();

        mm.add( '(max-width: 1023px)', () => {
          $( wave ).addClass( 'is-loaded' );
        } );

        mm.add( '(min-width: 1024px)', () => {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              pin: true,
              start: 'top ' + topOffset,
              end: '+=' + ( height * 3 ),
              scrub: 1,
              // markers: true,
            },
          } );
          tl.to( wave, {y: '-150vh', ease: 'linear'}, 0 );
        } );
      } );

      // Canvas Init
      const c = document.getElementById( 'bubbles' );
      const ctx = c.getContext( '2d' );
      let width = $( '.animating-hero__wave-wrapper' ).width();
      let height = $( '.animating-hero__wave-wrapper' ).height();
      const particles = 60;
      const minRadius = 5;
      const maxRadius = 20;
      let speed = 0.01;
      const x = width / particles;

      if ( window.innerWidth < 1024 ) {
        speed = 0.0001;
      }

      // Bubbles
      const Bubbles = [];

      for ( let i = 0; i < particles; i++ ) {
        Bubbles.push( {
          x: i * x,
          y: height * Math.random(),
          r: minRadius + Math.random() * ( maxRadius - minRadius ),
          speed: 10 * Math.random(),
        } );
      }

      function bubble() {
        c.width = width;
        c.height = height;
        for ( let i = 0; i < Bubbles.length; i++ ) {
          const b = Bubbles[i];
          ctx.beginPath();
          ctx.arc( b.x, b.y, b.r, 0, 2 * Math.PI );

          b.alpha = .5 * ( b.y / height );
          b.speed += speed;

          ctx.globalAlpha = b.alpha;
          ctx.strokeStyle = 'rgba(255, 255, 255, .5)';
          ctx.stroke();
          ctx.fillStyle = 'rgba(255, 255, 255, 0.3)';
          ctx.fill();
          b.y -= b.speed;
          if ( b.y < 0 ) {
            b.y = height;
            b.speed = Math.random() * 5;
          }
        }
      }

      // Draw
      function draw() {
        bubble();
        window.requestAnimationFrame( draw );
      }

      // Resize Canvas
      function resizeCanvas() {
        width = $( '.animating-hero__wave-wrapper' ).width();
        height = $( '.animating-hero__wave-wrapper' ).height();
        c.width = width;
        c.height = height;
        draw();
      }
      resizeCanvas();
      window.addEventListener( 'resize', resizeCanvas, false );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'animating-hero', COMPONENT );
} )( app );
